(function () {
    angular
        .module('invesfleet')
        .directive('inScroll', arrowScrollDirective);

    arrowScrollDirective.$inject = [];

    function arrowScrollDirective() {
        return {
            scope: true,
            restrict: 'A',
            controller: arrowScrollController
        };
    }

    function arrowScrollController($scope) {
        this.overflow = false;
        this.targetTab = 0;
        this.onTarget = true;

        this.getOffset = getOffset;

        this.notOnTarget = function(){
            this.onTarget = false;
            this.startAnimationCallback();
        };

        this.startAnimationCallback = function(){};

        function getOffset(tab) {
            return this.children[tab].offsetLeft - this.container.offsetLeft;
        }
    }

    arrowScrollController.$inject = ['$scope'];

    angular.module('invesfleet')
        .directive('inScrollArrow', arrowScrollLinkDirective);

    function arrowScrollLinkDirective() {
        return {
            scope: false,
            restrict: 'A',
            require: '^inScroll',
            link: function (scope, element, attributes, ctr) {

                //Scroll left or right to the next element
                var scrollTabs = function () {
                    var maxScroll = ctr.container.scrollWidth - ctr.container.offsetWidth;
                    var dir = attributes.inScrollArrow;
                    if (dir === 'left' && ctr.targetTab > 0) {
                        ctr.targetTab--;
                        ctr.notOnTarget();
                    } else if (dir === 'right' && ctr.getOffset(ctr.targetTab) < maxScroll) {
                        ctr.targetTab++;
                        ctr.notOnTarget();
                    }
                };

                element.bind('click', function () {
                    scope.$apply(function () {
                        scrollTabs();
                    });
                });

                element.bind('mouseover', function () {
                    scope.$apply(function () {
                        scrollTabs();
                    });
                });

                function isArrowActive(dir) {
                    if (dir === 'left') {
                        return ctr.targetTab > 0;
                    } else if (dir === 'right') {
                        return ctr.targetTab < getMaxTab();
                    }
                }

                function getMaxTab() {
                    var maxScroll = ctr.container.scrollWidth - ctr.container.offsetWidth;
                    for (var i = 0; i < ctr.children.length; i++) {
                        if ((ctr.children[i].offsetLeft - ctr.container.offsetLeft) >= maxScroll) { return i; }
                    }
                }

                scope.$watch(function () {return ctr.targetTab;}, function () {
                    element.toggleClass('active', isArrowActive(attributes.inScrollArrow));
                });

                scope.$watch(function () {return ctr.container.scrollWidth > ctr.container.offsetWidth;}, function () {
                    element.toggleClass('overflow', ctr.container.scrollWidth > ctr.container.offsetWidth);
                    element.toggleClass('active', isArrowActive(attributes.inScrollArrow));
                });

            }
        };
    }

    angular.module('invesfleet')
        .directive('inScrollContainer', arrowScrollPaneDirective);

    function arrowScrollPaneDirective() {
        return {
            scope: false,
            restrict: 'A',
            require: '^inScroll',
            link: function (scope, element, attributes, ctr) {

                var STEP_SIZE = 7; //Pixels per frame

                var lastWidth = 0;
                var lastScrollWidth = 0;

                ctr.container = element[0];
                ctr.children = element[0].children;

                ctr.startAnimationCallback = onframe;

                function onframe() {
                    scope.overflow = ctr.container.scrollWidth > ctr.container.offsetWidth;
                    if (ctr.container.offsetWidth !== lastWidth) { lastWidth = ctr.container.offsetWidth; reset(); }
                    if (ctr.container.scrollWidth !== lastScrollWidth) {
                        lastScrollWidth = ctr.container.scrollWidth; reset();
                    }

                    takeStep();

                    if(!ctr.onTarget){
                        requestAnimationFrame(onframe); //PELIGRO MEMORY LEAK?
                    }
                }

                function takeStep() {
                    if (ctr.onTarget) { return; }
                    if (ctr.targetTab < 0 || ctr.targetTab >= ctr.children.length) { reset(); return; }

                    var maxScroll = ctr.container.scrollWidth - ctr.container.offsetWidth;
                    var targetOffset = ctr.getOffset(ctr.targetTab);
                    var sign = Math.sign(targetOffset - ctr.container.scrollLeft);
                    var step = sign * STEP_SIZE;

                    if (ctr.container.scrollLeft + step >= maxScroll) {
                        ctr.container.scrollLeft = maxScroll;
                        ctr.onTarget = true;
                    }
                    else if (ctr.container.scrollLeft + step >= targetOffset && sign >= 0 ||
                        ctr.container.scrollLeft + step <= targetOffset && sign < 0) {
                        ctr.container.scrollLeft = targetOffset;
                        ctr.onTarget = true;
                    } else {
                        ctr.container.scrollLeft += step;
                    }
                }

                function reset() {
                    ctr.targetTab = 0;
                    ctr.onTarget = true;
                    ctr.container.scrollLeft = 0;
                }
            }
        };
    }

})();